import { z } from 'zod';
import { ROOM_CODE_LENGTH, MAX_PLAYERS_PER_ROOM } from '../constants/game.constants.js';
export const loginGuestSchema = z.object({
    displayName: z
        .string()
        .min(2, 'Display name must be at least 2 characters')
        .max(30, 'Display name must be at most 30 characters')
        .trim(),
});
export const createRoomSchema = z.object({
    name: z
        .string()
        .min(3, 'Room name must be at least 3 characters')
        .max(50, 'Room name must be at most 50 characters')
        .trim(),
    maxPlayers: z
        .number()
        .int()
        .min(2)
        .max(MAX_PLAYERS_PER_ROOM)
        .default(50),
    ticketPrice: z.number().int().min(0).default(0),
    isPrivate: z.boolean().default(false),
    settings: z
        .object({
        autoCall: z.boolean().default(true),
        callInterval: z.number().int().min(3).max(30).default(5),
        maxTicketsPerPlayer: z.number().int().min(1).max(6).default(3),
        enableChat: z.boolean().default(true),
        allowLateMarking: z.boolean().default(true),
    })
        .optional(),
});
export const joinRoomSchema = z.object({
    code: z
        .string()
        .length(ROOM_CODE_LENGTH, `Room code must be ${ROOM_CODE_LENGTH} characters`)
        .toUpperCase(),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
//# sourceMappingURL=schemas.js.map